import { Notify } from 'quasar'
import SprintsService from 'src/services/sprints'
import OrganizationService from 'src/services/organization'
import ActionPlanTask from 'src/models/ActionPlanTask.model'
import { useUsersStore, useRolesStore } from 'src/stores/index.js'

export default {
  // Mision Sprints
  allUsers () {
    const usersStore = useUsersStore()
    const users = usersStore.users.map(user => user.id)
    this.newMissionSprint.assigned_to = users
  },
  async getTemporarySprint () {
    let data = []
    await SprintsService.getTemporarySprint()
      .then(res => {
        data = res
      })

    return data
  },
  putRestoredSprint (payload) {
    this.newMissionSprint= payload
  },
  async createSprint (tab) {
    const obj = { ...this.newMissionSprint }
    await SprintsService.createMissionSprint(obj)
      .then(async () => {
        this.missionSprints.push(obj)

        await SprintsService.deleteTemporary()
        await SprintsService.getMissionSprint({ filterBy: tab })
          .then(async res => {
            this.missionSprints = res
          })
      })
  },
  deleteMissionSprints (id) {
    this.loading = true
    
    SprintsService.deleteMissionSprint(id)
      .then(() => {
        this.missionSprints = this.missionSprints.filter((sprint) => sprint.id !== id)
      })
      .finally(() => { this.loading = false })
  },
  checkIsSupervisor () {
    SprintsService.checkIsSupervisor()
      .then(res => { this.isSupervisor = res.data })
  },
  async getMissionSprints (payload) {
    this.loading = true
    this.missionSprints = []

    await SprintsService.getMissionSprint(payload)
      .then(async res => {
        // obtener el semaforo
        await OrganizationService.getSemaphoreSprints()
          .then(res => {
            if (res.status === 'success') {
              const data = JSON.parse(res.data[0].data)
              const semaphore = data[0].semaphore
              this.semaphore = {
                red: semaphore[0],
                amber: semaphore[1],
                green: semaphore[2]
              }
            }
          })

        this.missionSprints = res
      })
      .finally(() => { this.loading = false })
  },
  async updateSprintDetails ({ sprint_id, supervisor }) {
    let details = []
    let status = 'ok'
    if (supervisor) {
      await SprintsService.getMissionSprintDetailsSupervisor({ sprint_id, supervisor })
        .then(res => {
          if (Array.isArray(res)) details = res.filter(loc => loc !== null)
        })
        .catch(() => { status = 'error' })
    } else {
      await SprintsService.getMissionSprintDetails(sprint_id)
        .then(res => {
          if (Array.isArray(res)) details = res.filter(loc => loc !== null)
        })
        .catch(() => { status = 'error' })
    }
    this.sprintDetails = details
    return status
  },
  resetSprintDetails () {
    this.sprintDetails = []
  },
  getSprintTasks (options) {
    this.sprintsReviewTasks = []
    let payload = {
      limit: 15,
      page: 1,
      ...options
    }
    return SprintsService.getSprintTasks(payload)
      .then(response => {
        this.sprintTasks = response.data.map(task => {
          return new ActionPlanTask(task)
        })
        const pagination = {
          page: payload.page,
          rowsPerPage: payload.limit,
          rowsNumber: response.total
        }
        this.sprintPagination = pagination
      })
      .catch(error => {
        console.error(error)
      })
  },
  resetSprintTasks () {
    this.sprintTasks = []
  },
  updateSemaphore (payload) {
    this.loading = true

    OrganizationService.saveSemaphoreSprints(payload)
      .then(() => {
        this.semaphore = payload
      })
      .finally(() => {
        this.loading = false
      })
  },
  async getSemaphore () {
    this.loading = true

    await OrganizationService.getSemaphoreSprints()
      .then(res => {
        if (res.status === 'success') {
          const data = JSON.parse(res.data[0].data)
          const semaphore = data[0].semaphore
          this.semaphore = {
            red: semaphore[0],
            amber: semaphore[1],
            green: semaphore[2]
          }
        }
      })

    this.loading = false
  },
  resetNewMissionSprint () {
    this.newMissionSprint = {
      name: null,
      category: null,
      location_id: [],
      role_id: null,
      role_franchise_id: null,
      assigned_to: null,
      priority: 1,
      end_date: null,
      start_date: null,
      tasks: [],
      type: null,
      review_time: { label: '1 día', value: 24 },
      have_review: false,
      review_in_execution: false,
      have_supervisor: false,
      reviewer_role_id: null,
      reviewers: [],
      supervisors: []
    }
  },
  updateSprintTaskTitle (payload) {
    this.newMissionSprint.tasks[payload.index].title = payload.title
  },
  updateSprintName (name) {
    this.newMissionSprint.name = name
  },
  updateSprintLocations (locations) {
    this.newMissionSprint.location_id = locations
  },
  updateSprintRole (role) {
    const usersStore = useUsersStore()
    const rolesStore = useRolesStore()

    const preserveExistingFranchiseId = this.newMissionSprint.role_franchise_id !== null

    if (role && usersStore.currentIsOrganizationAdmin) {
      const rolFranchise = rolesStore.rolesByFranchises.find(r => r.id === role)
      if (rolFranchise) {
        this.newMissionSprint.role_franchise_id = rolFranchise.franchise_role_id
      } else if (!preserveExistingFranchiseId) {
        this.newMissionSprint.role_franchise_id = null
      }
    } else if (role) {
      const rolFranchise = rolesStore.roles.find(r => r.id === role)
      if (rolFranchise) {
        this.newMissionSprint.role_franchise_id = rolFranchise.franchise_role_id
      } else if (!preserveExistingFranchiseId) {
        this.newMissionSprint.role_franchise_id = null
      }
    } else {
      this.newMissionSprint.role_franchise_id = null
    }

    if (this.newMissionSprint.have_review) {
      this.newMissionSprint.reviewer_role_id = null
    }

    this.newMissionSprint.role_id = role
  },
  updateSprintUsers (users) {
    this.newMissionSprint.assigned_to = users
  },
  updateHaveReview (payload) {
    this.newMissionSprint.have_review = payload
  },
  updateReviewInExecution (payload) {
    this.newMissionSprint.review_in_execution = payload
  },
  updateHaveSupervisor (payload) {
    this.newMissionSprint.have_supervisor = payload
  },
  updateSprintReviewTime (time) {
    this.newMissionSprint.review_time = time
  },
  updateReviewers (reviewers) {
    this.newMissionSprint.reviewers = reviewers
  },
  updateSearchSupervisor (payload) {
    const currentState = this.newMissionSprint.supervisors
    const haveRole = currentState.some(role => role.supervisor_role_id === payload.supervisor_role_id)
    if (haveRole) {
      const index = currentState.findIndex(role => role.supervisor_role_id === payload.supervisor_role_id)
      currentState[index].supervisors.push(payload.supervisor)
    } else {
      const newRole = {
        supervisor_role_id: payload.supervisor_role_id,
        supervisors: [payload.supervisor]
      }
      currentState.push(newRole)
    }
    this.newMissionSprint.supervisors = currentState
  },
  updateSupervisors (payload) {
    const currentState = this.newMissionSprint.supervisors
    const havingRole = currentState.some(el => el.supervisor_role_id === payload.supervisor_role_id)

    if (havingRole) {
      const index = currentState.findIndex(el => el.supervisor_role_id === payload.supervisor_role_id)
      const deletedSet = currentState.splice(index, 1, payload)

      this.selectedSupervisors = this.selectedSupervisors.filter(sup => !deletedSet[0].supervisors.includes(sup.id))
    } else {
      currentState.push(payload)
    }
    this.newMissionSprint.supervisors = currentState
  },
  removeSupervisorSet (index) {
    const currentState = this.newMissionSprint.supervisors
    const deletedSet = currentState.splice(index, 1)
    this.selectedSupervisors = this.selectedSupervisors.filter(sup => !deletedSet[0].supervisors.includes(sup.id))

    this.newMissionSprint.supervisors = currentState
  },
  updateSelectedSupervisors (filteredUsers) {
    const currentState = this.selectedSupervisors
    const stateIds = currentState.map(el => el.id)
    filteredUsers.map(el => {
      const haveOne = stateIds.includes(el.id)
      if (!haveOne) currentState.push(el)
    })
    this.selectedSupervisors = currentState
  },
  updateSearchSelectedSupervisors (user) {
    this.selectedSupervisors.push(user)
  },
  resetSupervisors () {
    this.newMissionSprint.supervisors = []
    this.selectedSupervisors = []
  },
  resetSelectedSupervisors () {
    this.selectedSupervisors = []
  },
  updateReviewerRoleId (roleId) {
    this.newMissionSprint.reviewer_role_id = roleId
  },
  updateSprintEndDate (endDate) {
    this.newMissionSprint.end_date = endDate
  },
  updateSprintStartDate (startDate) {
    this.newMissionSprint.start_date = startDate
  },
  updateSprintPriority (priority) {
    switch (priority) {
      case 'Alta':
        priority = 3
        break
      case 'Media':
        priority = 2
        break
      case 'Baja':
        priority = 1
        break
      default:
        priority = null
        break
    }
    this.newMissionSprint.priority = priority
  },
  updateSprintTasks (payload) {
    this.newMissionSprint.tasks = payload
  },
  updateSprintType (payload) {
    this.newMissionSprint.type = payload
  },
  downloadSprintReport (sprintId) {
    this.loading = true

    SprintsService.downloadSprintReport(sprintId)
      .then(res => {
        if (res?.queued) {
          Notify.create({
            type: 'positive',
            message: res.message || 'El PDF se está generando y te llegará por correo en unos minutos.',
            timeout: 8000,
            position: 'top'
          })
        }
      })
      .catch(() => {})
      .finally(() => {
        this.loading = false
      })
  },

  // Sprint review
  resetSprintsReviewTasks () {
    this.sprintsReviewTasks = []
  },
  updateSprintsReviewTasks ({ type, taskId }) {
    const isCurrent = this.sprintsReviewTasks.some(el => el.id === taskId)
    let payload

    if (isCurrent) {
      if (type === 'approved' || type === 'rejected') {
        const currentState = this.sprintsReviewTasks
        const index = currentState.findIndex(task => task.id === taskId)
        currentState.splice(index, 1, { id: taskId, type })
        payload = currentState
      } else payload = this.sprintsReviewTasks.filter(el => el.id !== taskId)
    } else if (!isCurrent && (type === 'approved' || type === 'rejected')) {
      payload = this.sprintsReviewTasks
      payload.push({ id: taskId, type })
    }
    if (payload) {
      const index = this.sprintTasks.findIndex(task => task.id === taskId)
      this.sprintTasks[index].review_status = type === null ? 'notReviewed' : type
      this.sprintsReviewTasks = payload
    }
  },
  updateReviewTasksComment ({ taskId, reviewComment }) {
    this.sprintsReviewTasks = this.sprintsReviewTasks.map(task =>
      task.id === taskId ? { ...task, review_comment: reviewComment } : task
    )
  },
  async resolveTasksReview ({ sprint_id, supervisor }) {
    const payload = { tasks: this.sprintsReviewTasks, sprint_id }
    let promise = 'error'
    await SprintsService.resolveTasksReview(payload)
      .then(async () => {
        promise = 'ok'
        await this.updateSprintDetails({ sprint_id, supervisor })
        await SprintsService.getUpdateScore(sprint_id)
          .then(data => {
            this.missionSprints = this.missionSprints.map(sprint =>
              sprint.id === sprint_id ? { ...sprint, score: data.score } : sprint
            )
          })
      })
      .catch((e) => {
        if (e.status === 400) promise = 'quit'
      })

    return promise
  },
  async finishSprintReview (payload) {
    let promise = 'error'
    await SprintsService.finishSprintReview(payload)
      .then(() => { promise = 'ok' })
      .catch(e => {
        if (e.status === 400) promise = 'quit'
      })
    return promise
  },
  removeSprint (sprintId) {
    this.missionSprints = this.missionSprints.filter(sprint => sprint.id !== sprintId)
  },
  deselectUsersSprints () {
    this.newMissionSprint.assigned_to = []
  }
}
